import React, { useState } from 'react';

export interface SimulatorFormData {
  totalAmount: number;
  advance: number | string;
  rate: number | string;
  fundRate: number;
  arrearRate: number | string;
  arrearType: 'rate' | 'table';
  guaranteeAmount: number;
  guaranteeObservation: string;
  operationCostComissionFixed: number;
  operationCostComissionVariable: number;
  operationCostComissionVariablePercentage: number | string;
  expensesCost: number;
  requestDate: string;
  paymentDate: string;
  amountToApply: number;
  selectedDocumentsToApply: string[];
  arrearTableId?: string;
}

export const initialFormData: SimulatorFormData = {
  totalAmount: 0,
  advance: '',
  rate: 0,
  fundRate: 0,
  arrearRate: 0,
  arrearType: 'rate',
  guaranteeAmount: 0,
  guaranteeObservation: '',
  operationCostComissionFixed: 0,
  operationCostComissionVariable: 0,
  operationCostComissionVariablePercentage: 0,
  expensesCost: 0,
  requestDate: new Date().toISOString(),
  paymentDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
  amountToApply: 0,
  selectedDocumentsToApply: [],
};

export interface SimulatorFormDataProps {
  formData: SimulatorFormData;
  setFormData: React.Dispatch<React.SetStateAction<SimulatorFormData>>;
}

const useSimulatorFormData = () => {
  const [formData, setFormData] = useState<SimulatorFormData>(initialFormData);

  const resetFormData = () => {
    setFormData(initialFormData);
  };

  return {
    formData,
    setFormData,
    resetFormData,
  };
};

export default useSimulatorFormData;
